<template>
  <DashboardPage>
    <CompanyForm :id="route.params.id" />
  </DashboardPage>
</template>
  
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue'

import CompanyForm from './components/CompanyForm.vue'

const route = useRoute()

</script>